<template>
    <b-dropdown
        v-b-tooltip.hover
        variant="transparent"
        class="well-status-dropdown"
        :title="$translate('status')"
        no-caret
    >
        <template #button-content>
            <slot />
        </template>

        <b-dropdown-item
            v-for="(wellInfo, key) in config"
            :key="key"
            @click="changeWellStatus(key)"
        >
            <div
                v-b-tooltip.hover
                :class="{ 'well-status': wellInfo.iconColor }"
                :title="$translate(wellInfo.label)"
            >
                <img
                    :src="`${WELL_STATUS_ICONS_PATH}/${key}.svg`"
                    :class="wellInfo.iconClass"
                    alt=""
                />
            </div>
        </b-dropdown-item>

        <b-dropdown-item v-if="well.status" @click="changeWellStatus(well.status)">
            <span class="well-status na-button" :title="$translate('na')">
                {{ $translate('na') }}
            </span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { WELL_STATUS_ICONS_PATH } from '../../../business/const'
import { WELL_STATUS } from '../../../business/factory/DataModel'

export default {
    name: 'WellStatusDropdown',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            WELL_STATUS_ICONS_PATH,
            config: {
                [WELL_STATUS.PENDING]: {
                    label: 'pending',
                    iconClass: 'pending-button back-colored',
                    iconColor: 'yellow'
                },
                [WELL_STATUS.FROZEN]: {
                    label: 'freeze',
                    iconClass: 'frozen-button back-colored',
                    iconColor: 'blue'
                },
                [WELL_STATUS.THAWED]: {
                    label: 'thawed',
                    iconClass: 'thawed-button back-colored',
                    iconColor: 'purple'
                },
                [WELL_STATUS.TRANSFERRED]: {
                    label: 'transfer',
                    iconClass: 'transferred-button back-colored',
                    iconColor: 'green'
                },
                [WELL_STATUS.DISCARDED]: {
                    label: 'discard',
                    iconClass: 'discard-button back-colored',
                    iconColor: 'red'
                }
            }
        }
    },
    methods: {
        changeWellStatus(status) {
            this.$mainController.changeWellStatus(this.well, status)
        }
    }
}
</script>

<style lang="scss" scoped>
.well-status-dropdown {
    .dropdown-menu {
        min-width: 0;
        border: none;
        background-color: transparent !important;

        li {
            margin-top: -0.2rem;
        }
        .well-status {
            border-radius: 0.2rem;
            height: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14pt;
            background-color: transparent !important;

            &.na-button {
                font-size: 12px;
                border-radius: 0.2rem;
                border: 1px solid $gray-500;
            }

            img {
                @media screen and #{$new-break2close} {
                    height: 1.8rem;

                    &.back-colored {
                        padding: 0.25rem;
                        border-radius: 0.2rem;
                    }
                    &.pending-button {
                        border: 1px solid $yellow;
                    }
                    &.discard-button {
                        border: 1px solid $red;
                    }
                    &.transferred-button {
                        border: 1px solid $green;
                    }
                    &.frozen-button {
                        border: 1px solid $frozen-color;
                    }
                    &.thawed-button {
                        border: 1px solid $purple;
                    }
                }
            }
        }
    }

    .dropdown-item {
        padding: 0.3rem 0;
        width: auto;
    }

    .dropdown-toggle {
        &[aria-expanded='true'] {
            i {
                &.fa:before {
                    content: '\f078';
                }

                &.transferred-button,
                &.pending-button,
                &.frozen-button,
                &.thawed-button,
                &.discard-button {
                    color: $light-3;
                    font-size: 11pt !important;
                    -webkit-text-stroke: 0 $light !important;
                }
            }
        }

        &::after {
            display: none;
        }
    }
}
</style>

<style lang="scss">
.well-status-dropdown {
    .dropdown-menu {
        margin-top: 4rem;

        @media screen and #{$new-break2close} {
            margin: 0;
            min-width: 0;
        }
    }
}
</style>
